
export enum Size {
    A4 = 'A4',
    A3 = 'A3',
}
export const PRICE_TABLE: {[size in Size]: number} = {
    [Size.A4]: 20,
    [Size.A3]: 20,
}
